import React from 'react'

const ErrorScreen = ({ review, error }) => {
  return (
    <div className={`product-review-error`}>
      <div className="intro">
        <h1>Error</h1>
        <div className="detail">
          We're sorry, an unxpected error has occured:
          <br />
          {error && (
            <pre>{`
error: ${error.error}
message: ${error.message}
timestamp: ${error.timestamp}
                    `}</pre>
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorScreen
